// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { Button, TablePagination } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import InputBase from "@mui/material/InputBase";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import React, { useState, useEffect } from "react";
// import Modal from "../Modal";
// import AddNewCandidate from "../AddNewCandidate";
// import DownloadIcon from "@mui/icons-material/Download";
// import EditPopup from "../EditPopup";
// import Toast from "../../../utils/toast";
// import createInstance from "../../../api/axiosinstance";
// import DeleteCandidateModal from "../DeleteCandidateModal";
// import { toast } from "react-toastify";

// const ViewCandidate = ({ onOpenCandidate }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const [isAddCandidateOpen, setIsAddCandidateOpen] = useState(false);
//   const [data, setData] = useState([]);
//   const [editOrView, setEditOrView] = useState("");
//   const [openPopup, setOpenPopup] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [actionType, setActionType] = useState("delete");
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [candidateIdToDelete, setCandidateIdToDelete] = useState("");
//   const [formData, setFormData] = useState({
//     candidate_id: "",
//     candidate_full_name: "",
//     email_id: "",
//     job_title: "",
//     job_id: "",
//     skills: "",
//     educational_qualification: "",
//     experience_years: "",
//     experience_months: "",
//   });
//   const organizationId = window.sessionStorage.getItem("organizationId");

//   // Fetch candidates on page load
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Get all candidates
//   const fetchData = async () => {
//     try {
//       const response = await aiDishaApi.get(`/get-candidates-by-org-id/?org_id=${organizationId}`);
//       setData(response.data["candidates"]);
//       console.log("Candidates:", response.data["candidates"]);
//     } catch (error) {
//       console.error("Error fetching candidates:", error.message);
//       Toast.error("Failed to fetch candidates. Please try again.");
//     }
//   };

//   // Search candidates by name
//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const filteredCandidates = data.filter((row) =>
//     row.candidate_full_name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Add new candidate
//   const handleAddCandidate = () => {
//     onOpenCandidate();
//   };

//   // Pagination
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Delete candidate modal
//   const handleOpenDeleteModal = (candidateId) => {
//     setCandidateIdToDelete(candidateId);
//     setDeleteModalOpen(true);
//   };

//   const handleCloseDeleteModal = () => {
//     setDeleteModalOpen(false);
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//   };

//   // Download resume
//   const handleDownload = (resumeUrl) => {
//     const link = document.createElement("a");
//     link.href = resumeUrl;
//     link.download = resumeUrl.split("/").pop();
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Validate form inputs
//   const validateForm = () => {
//     if (!organizationId) {
//       Toast.error("Organization ID is missing.");
//       return false;
//     }
//     if (!formData.candidate_full_name) {
//       Toast.error("Full Name is required.");
//       return false;
//     }
//     if (!formData.email_id) {
//       Toast.error("Email ID is required.");
//       return false;
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_id)) {
//       Toast.error("Invalid email format.");
//       return false;
//     }
//     if (!formData.job_title) {
//       Toast.error("Job Title is required.");
//       return false;
//     }
//     if (!formData.educational_qualification) {
//       Toast.error("Qualification is required.");
//       return false;
//     }
//     if (!formData.skills) {
//       Toast.error("Skills are required.");
//       return false;
//     }
//     if (!formData.experience_years || isNaN(formData.experience_years)) {
//       Toast.error("Experience in years must be a number.");
//       return false;
//     }
//     if (!formData.experience_months || isNaN(formData.experience_months)) {
//       Toast.error("Experience in months must be a number.");
//       return false;
//     }
//     return true;
//   };

//   // Update candidate
//   const handleEditJob = async (event) => {
//     event.preventDefault();
//     console.log("Form data:", formData);

//     const isValid = validateForm();
//     if (!isValid) {
//       return;
//     }

//     try {
//       const response = await aiDishaApi.put(
//         "/update-candidate/", // Correct endpoint with hyphen
//         null,
//         {
//           params: {
//             organization_id: organizationId,
//             candidate_id: formData.candidate_id,
//             candidate_full_name: formData.candidate_full_name, // Correct field name
//             email_id: formData.email_id,
//             job_title: formData.job_title,
//             skills: formData.skills || "",
//             educational_qualification: formData.educational_qualification || "",
//             experience_years: parseInt(formData.experience_years) || 0,
//             experience_months: parseInt(formData.experience_months) || 0,
//           },
//         }
//       );

//       console.log("Response:", response.data);
//       if (response.status === 200) {
//         Toast.success("Candidate details updated successfully!");
//         fetchData(); // Refresh candidate list
//         clearForm();
//         handlePopupClose();
//       } else {
//         Toast.error("Failed to update candidate details. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating candidate:", error);
//       if (error.response) {
//         if (error.response.status === 404) {
//           Toast.error("Candidate update endpoint not found. Please verify the server URL and endpoint.");
//         } else if (error.response.status === 400) {
//           Toast.error("Invalid data provided. Please check the form inputs.");
//         } else {
//           Toast.error(`Failed to update candidate: ${error.response.data.detail || "Unknown error"}`);
//         }
//       } else {
//         Toast.error("Network error. Please check your connection and try again.");
//       }
//     }
//   };

//   // Close popup
//   const handlePopupClose = () => {
//     setOpenPopup(false);
//   };

//   // Fetch candidate details
//   const getSelectedCandidateDetails = async (candidateId) => {
//     try {
//       const response = await aiDishaApi.get(`/get-candidates-by-candidate-id?candidate_id=${candidateId}`);
//       if (response.data) {
//         copyCandidateDetails(response.data);
//       } else {
//         Toast.error("No candidate data found.");
//         throw new Error("No data returned for candidate");
//       }
//     } catch (error) {
//       console.error("Error fetching candidate details:", error);
//       throw error;
//     }
//   };

//   // Handle view/edit candidate
//   const handleViewEditCandidate = async (candidateId, reason) => {
//     console.log("CandidateID:", candidateId);
//     console.log("Reason:", reason);

//     try {
//       await getSelectedCandidateDetails(candidateId);
//       setEditOrView(reason);
//       setOpenPopup(true);
//     } catch (error) {
//       console.error(`Error in ${reason} candidate:`, error);
//       Toast.error("Something went wrong while fetching candidate details.");
//     }
//   };

//   // Delete candidate
//   const handleDeleteCandidate = () => {
//     aiDishaApi
//       .put(`/delete-candidate/?candidate_id=${candidateIdToDelete}`)
//       .then((response) => {
//         toast.success("Candidate deleted");
//         fetchData();
//         setDeleteModalOpen(false);
//       })
//       .catch((error) => {
//         console.error("Error deleting candidate:", error);
//         Toast.error("Failed to delete candidate");
//         setDeleteModalOpen(false);
//       });
//   };

//   // Copy candidate details to formData
//   const copyCandidateDetails = (candidateData) => {
//     let years = "";
//     let months = "";

//     if (candidateData.experience) {
//       years = Math.floor(candidateData.experience);
//       months = Math.round((candidateData.experience - years) * 12);
//     }

//     setFormData({
//       ...formData,
//       candidate_id: candidateData.candidate_id,
//       candidate_full_name: candidateData.candidate_full_name,
//       email_id: candidateData.email_id,
//       job_title: candidateData.job_title,
//       job_id: candidateData.job_id,
//       skills: candidateData.skills || "",
//       educational_qualification: candidateData.educational_qualification,
//       experience_years: years,
//       experience_months: months,
//     });
//   };

//   // Clear form
//   const clearForm = () => {
//     setFormData({
//       candidate_id: "",
//       candidate_full_name: "",
//       email_id: "",
//       job_title: "",
//       job_id: "",
//       skills: "",
//       educational_qualification: "",
//       experience_years: "",
//       experience_months: "",
//     });
//   };

//   const candidate_headers = [
//     {
//       candidateId: "Candidate ID",
//       candidateName: "Candidate Name",
//       email: "Email ID",
//       file_name: "Resume",
//       action: "Action",
//     },
//   ];

//   return isAddCandidateOpen ? (
//     <Box
//       sx={{
//         marginTop: "25px",
//         borderRadius: "10px",
//         backgroundColor: "#33333",
//         maxHeight: "calc(100vh - 120px)",
//         overflowY: "auto",
//       }}
//     >
//       <AddNewCandidate />
//     </Box>
//   ) : (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         width: "100%",
//         overflow: "scroll",
//         overflowX: "hidden",
//       }}
//     >
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 1%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}
//           >
//             View Candidate
//           </Typography>
//         </Box>

//         <Box
//           gridColumn="span 8"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Paper
//             sx={{
//               p: "2px 4px",
//               display: "flex",
//               width: "75%",
//               borderRadius: 2,
//               backgroundColor: "#033538",
//             }}
//           >
//             <IconButton
//               type="button"
//               sx={{ p: "8px", color: "white" }}
//               aria-label="search"
//             >
//               <SearchIcon />
//             </IconButton>
//             <InputBase
//               sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }}
//               placeholder="Search by Candidate Name"
//               inputProps={{ "aria-label": "search google maps" }}
//               value={searchTerm}
//               onChange={handleSearch}
//             />
//           </Paper>
//         </Box>

//         <Box
//           gridColumn="span 4"
//           sx={{ marginTop: "auto", textAlign: "center" }}
//         >
//           <Button
//             variant="contained"
//             onClick={handleAddCandidate}
//             sx={{
//               backgroundColor: "#033538",
//               marginRight: "10px",
//               color: "white",
//               fontFamily: "poppins",
//             }}
//           >
//             Add New Candidate
//           </Button>
//         </Box>
//       </Box>
//       <Box sx={{ backgroundColor: "#33333" }} justifyContent="center">
//         <Grid container spacing={1} sx={{ justifyContent: "center" }}>
//           <Grid item xs={12} sm={10} md={10} justifyContent="center">
//             <TableContainer
//               component={Paper}
//               sx={{
//                 marginTop: "25px",
//                 borderRadius: "5px",
//                 maxHeight: "400px",
//                 overflowY: "auto",
//                 maxWidth: "100%",
//                 overflowX: "auto",
//               }}
//             >
//               <Table size="small">
//                 <TableHead sx={{ backgroundColor: "#006A71" }}>
//                   {candidate_headers.map((candidate) => (
//                     <TableRow key={candidate.candidateId}>
//                       <TableCell sx={{ color: "white", borderBottom: 0 }}>
//                         {candidate.candidateId}
//                       </TableCell>
//                       <TableCell sx={{ color: "white", borderBottom: 0 }}>
//                         {candidate.candidateName}
//                       </TableCell>
//                       <TableCell sx={{ color: "white", borderBottom: 0 }}>
//                         {candidate.email}
//                       </TableCell>
//                       <TableCell sx={{ color: "white", borderBottom: 0 }}>
//                         {candidate.file_name}
//                       </TableCell>
//                       <TableCell sx={{ color: "white", borderBottom: 0 }}>
//                         {candidate.action}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableHead>
//                 <TableBody>
//                   {filteredCandidates
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((candidate) => (
//                       <TableRow
//                         key={candidate.candidate_id}
//                         sx={{ backgroundColor: "#033538", marginRight: "10px" }}
//                       >
//                         <TableCell sx={{ color: "white", border: "1px solid black" }}>
//                           {candidate.candidate_id}
//                         </TableCell>
//                         <TableCell sx={{ color: "white", border: "1px solid black" }}>
//                           {candidate.candidate_full_name}
//                         </TableCell>
//                         <TableCell sx={{ color: "white", border: "1px solid black" }}>
//                           {candidate.email_id}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             color: "white",
//                             border: "1px solid black",
//                             maxWidth: "250px",
//                           }}
//                         >
//                           {candidate.resume_url && (
//                             <div>
//                               <span>
//                                 {new URL(candidate.resume_url).pathname.split("/").pop()}
//                               </span>
//                               <IconButton
//                                 onClick={() => handleDownload(candidate.resume_url)}
//                                 size="small"
//                                 sx={{ marginLeft: 1 }}
//                               >
//                                 <DownloadIcon fontSize="small" />
//                               </IconButton>
//                             </div>
//                           )}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             borderBottom: "1px solid black",
//                             borderRight: "1px solid black",
//                             alignItems: "center",
//                           }}
//                         >
//                           <Button
//                             variant="contained"
//                             sx={{
//                               backgroundColor: "black",
//                               color: "white",
//                               marginRight: "2px",
//                               fontFamily: "poppins",
//                               height: "20px",
//                               width: "50px",
//                             }}
//                             onClick={() =>
//                               handleViewEditCandidate(candidate.candidate_id, "View")
//                             }
//                           >
//                             View
//                           </Button>
//                           <Button
//                             variant="contained"
//                             sx={{
//                               backgroundColor: "black",
//                               color: "white",
//                               marginLeft: "10px",
//                               marginRight: "2px",
//                               fontFamily: "poppins",
//                               height: "20px",
//                               width: "50px",
//                             }}
//                             onClick={() =>
//                               handleViewEditCandidate(candidate.candidate_id, "Edit")
//                             }
//                           >
//                             Edit
//                           </Button>
//                           <Button
//                             variant="contained"
//                             sx={{
//                               color: "white",
//                               marginLeft: "10px",
//                               fontFamily: "poppins",
//                               height: "20px",
//                               width: "50px",
//                             }}
//                             color="error"
//                             onClick={() => handleOpenDeleteModal(candidate.candidate_id)}
//                           >
//                             Delete
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                 </TableBody>
//               </Table>
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 15]}
//                 component="div"
//                 count={filteredCandidates.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 sx={{
//                   backgroundColor: "#006A71",
//                   color: "white",
//                 }}
//               />
//             </TableContainer>
//           </Grid>
//         </Grid>
//       </Box>
//       <Modal isOpen={isModalOpen} onClose={handleModalClose} title="Candidate" />

//       <EditPopup
//         title="View/Edit Candidate"
//         openPopupVar={openPopup}
//         setOpenPopupMet={setOpenPopup}
//       >
//         <div
//           style={{
//             display: "block",
//             backgroundColor: "white",
//             width: "100%",
//             maxWidth: "1200px",
//           }}
//         >
//           <div className="modal-header border-0">
//             <label style={{ color: "black", fontSize: "18px" }}>{editOrView} Candidate</label>
//             <button type="button" className="btn-close" onClick={handlePopupClose}></button>
//           </div>

//           <form onSubmit={handleEditJob}>
//             <div className="row" style={{ margin: "0% 2%" }}>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="candidateId"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Candidate ID
//                 </label>
//                 <input
//                   type="text"
//                   name="candidateId"
//                   className="form-control form-control-sm"
//                   value={formData.candidate_id}
//                   onChange={(e) =>
//                     setFormData({ ...formData, candidate_id: e.target.value })
//                   }
//                   aria-label="Candidate ID"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   readOnly
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="candidateFullName"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Candidate Full Name
//                 </label>
//                 <input
//                   type="text"
//                   name="candidateFullName"
//                   className="form-control form-control-sm"
//                   value={formData.candidate_full_name}
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       candidate_full_name: e.target.value,
//                     })
//                   }
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="emailId"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Email ID
//                 </label>
//                 <input
//                   type="text"
//                   name="emailId"
//                   className="form-control form-control-sm"
//                   onChange={(e) =>
//                     setFormData({ ...formData, email_id: e.target.value })
//                   }
//                   value={formData.email_id}
//                   aria-label="Email ID"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="jobTitle"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Job Title
//                 </label>
//                 <input
//                   type="text"
//                   name="jobTitle"
//                   className="form-control form-control-sm"
//                   onChange={(e) =>
//                     setFormData({ ...formData, job_title: e.target.value })
//                   }
//                   value={formData.job_title}
//                   aria-label="Job Title"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="qualification"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Qualification
//                 </label>
//                 <input
//                   type="text"
//                   name="qualification"
//                   className="form-control form-control-sm"
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       educational_qualification: e.target.value,
//                     })
//                   }
//                   value={formData.educational_qualification}
//                   aria-label="Qualification"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="skills"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Skills
//                 </label>
//                 <input
//                   type="text"
//                   name="skills"
//                   className="form-control form-control-sm"
//                   onChange={(e) =>
//                     setFormData({ ...formData, skills: e.target.value })
//                   }
//                   value={formData.skills}
//                   aria-label="Skills"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="experienceYears"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Experience in Years
//                 </label>
//                 <input
//                   type="text"
//                   name="experienceYears"
//                   className="form-control form-control-sm"
//                   value={formData.experience_years}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       experience_years: e.target.value,
//                     })
//                   }
//                   aria-label="Experience in Years"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   className="aa"
//                   htmlFor="experienceMonths"
//                   style={{
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "#033538",
//                   }}
//                 >
//                   Experience in Months
//                 </label>
//                 <input
//                   type="text"
//                   name="experienceMonths"
//                   className="form-control form-control-sm"
//                   value={formData.experience_months}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       experience_months: e.target.value,
//                     })
//                   }
//                   aria-label="Experience in Months"
//                   style={{
//                     backgroundColor: "#033538",
//                     border: "none",
//                     width: "100%",
//                     fontFamily: "Poppins",
//                     fontSize: "12px",
//                     color: "white",
//                   }}
//                   disabled={editOrView === "View"}
//                 />
//               </div>
//             </div>

//             <div className="modal-footer d-flex flex-row justify-content-right border-0">
//               <button
//                 type="button"
//                 className="btn btn-sm rounded-2 fw-medium"
//                 onClick={clearForm}
//                 style={{
//                   color: "#033538",
//                   width: "120px",
//                   border: "1px solid #033538",
//                 }}
//                 hidden={editOrView === "View"}
//               >
//                 Clear
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-sm rounded-2 fw-medium"
//                 style={{
//                   backgroundColor: "#033538",
//                   color: "#E8E8E8",
//                   width: "120px",
//                 }}
//                 hidden={editOrView === "View"}
//               >
//                 Submit
//               </button>
//             </div>
//             <br />
//             <br />
//             <br />
//           </form>
//         </div>
//       </EditPopup>

//       <DeleteCandidateModal
//         open={deleteModalOpen}
//         onClose={handleCloseDeleteModal}
//         onConfirm={handleDeleteCandidate}
//       />
//     </div>
//   );
// };

// export default ViewCandidate;






import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Button, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions, Card, CardContent, Chip, LinearProgress, Typography as MuiTypography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useState, useEffect } from "react";
import Modal from "../Modal";
import AddNewCandidate from "../AddNewCandidate";
import DownloadIcon from "@mui/icons-material/Download";
import EditPopup from "../EditPopup";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";
import DeleteCandidateModal from "../DeleteCandidateModal";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import PsychologyIcon from "@mui/icons-material/Psychology";
import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const ViewCandidate = ({ onOpenCandidate }) => {
  const aiDishaApi = createInstance("DISHA");
  const [isAddCandidateOpen, setIsAddCandidateOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editOrView, setEditOrView] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [actionType, setActionType] = useState("delete");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [candidateIdToDelete, setCandidateIdToDelete] = useState("");
  
  // New states for AI screening modal
  const [aiScreeningOpen, setAiScreeningOpen] = useState(false);
  const [aiScreeningData, setAiScreeningData] = useState(null);
  const [loadingAiData, setLoadingAiData] = useState(false);
  
  const [formData, setFormData] = useState({
    candidate_id: "",
    candidate_full_name: "",
    email_id: "",
    job_title: "",
    job_id: "",
    skills: "",
    educational_qualification: "",
    experience_years: "",
    experience_months: "",
  });
  const organizationId = window.sessionStorage.getItem("organizationId");

  // Fetch candidates on page load
  useEffect(() => {
    fetchData();
  }, []);

  // Get all candidates
  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/get-candidates-by-org-id/?org_id=${organizationId}`);
      setData(response.data["candidates"]);
      console.log("Candidates:", response.data["candidates"]);
    } catch (error) {
      console.error("Error fetching candidates:", error.message);
      Toast.error("Failed to fetch candidates. Please try again.");
    }
  };

  // Fetch AI screening data
  const fetchAiScreeningData = async (candidateId) => {
    setLoadingAiData(true);
    try {
      // Replace this with your actual API endpoint
      const response = await aiDishaApi.get(`/get-candidates-resume_screening?candidate_id=${candidateId}`);
      console.log("candidate_resume_screening data:", response.data);
      setAiScreeningData(response.data);
      setAiScreeningOpen(true);
    } catch (error) {
      console.error("Error fetching AI screening data:", error);
      Toast.error("Failed to fetch AI screening data. Please try again.");
    } finally {
      setLoadingAiData(false);
    }
  };

  // Handle AI screening button click
  const handleAiScreening = (candidateId) => {
    console.log("handleAiScreening for candidateId:", candidateId);
    fetchAiScreeningData(candidateId);
  };

  // Close AI screening modal
  const handleCloseAiScreening = () => {
    setAiScreeningOpen(false);
    setAiScreeningData(null);
  };

  // Search candidates by name
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredCandidates = data.filter((row) =>
    row.candidate_full_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Add new candidate
  const handleAddCandidate = () => {
    onOpenCandidate();
  };

  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Delete candidate modal
  const handleOpenDeleteModal = (candidateId) => {
    setCandidateIdToDelete(candidateId);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // Download resume
  const handleDownload = (resumeUrl) => {
    const link = document.createElement("a");
    link.href = resumeUrl;
    link.download = resumeUrl.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Validate form inputs
  const validateForm = () => {
    if (!organizationId) {
      Toast.error("Organization ID is missing.");
      return false;
    }
    if (!formData.candidate_full_name) {
      Toast.error("Full Name is required.");
      return false;
    }
    if (!formData.email_id) {
      Toast.error("Email ID is required.");
      return false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_id)) {
      Toast.error("Invalid email format.");
      return false;
    }
    if (!formData.job_title) {
      Toast.error("Job Title is required.");
      return false;
    }
    if (!formData.educational_qualification) {
      Toast.error("Qualification is required.");
      return false;
    }
    if (!formData.skills) {
      Toast.error("Skills are required.");
      return false;
    }
    if (!formData.experience_years || isNaN(formData.experience_years)) {
      Toast.error("Experience in years must be a number.");
      return false;
    }
    if (!formData.experience_months || isNaN(formData.experience_months)) {
      Toast.error("Experience in months must be a number.");
      return false;
    }
    return true;
  };

  // Update candidate
  const handleEditJob = async (event) => {
    event.preventDefault();
    console.log("Form data:", formData);

    const isValid = validateForm();
    if (!isValid) {
      return;
    }

    try {
      const response = await aiDishaApi.put(
        "/update-candidate/", // Correct endpoint with hyphen
        null,
        {
          params: {
            organization_id: organizationId,
            candidate_id: formData.candidate_id,
            candidate_full_name: formData.candidate_full_name, // Correct field name
            email_id: formData.email_id,
            job_title: formData.job_title,
            skills: formData.skills || "",
            educational_qualification: formData.educational_qualification || "",
            experience_years: parseInt(formData.experience_years) || 0,
            experience_months: parseInt(formData.experience_months) || 0,
          },
        }
      );

      console.log("Response:", response.data);
      if (response.status === 200) {
        Toast.success("Candidate details updated successfully!");
        fetchData(); // Refresh candidate list
        clearForm();
        handlePopupClose();
      } else {
        Toast.error("Failed to update candidate details. Please try again.");
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      if (error.response) {
        if (error.response.status === 404) {
          Toast.error("Candidate update endpoint not found. Please verify the server URL and endpoint.");
        } else if (error.response.status === 400) {
          Toast.error("Invalid data provided. Please check the form inputs.");
        } else {
          Toast.error(`Failed to update candidate: ${error.response.data.detail || "Unknown error"}`);
        }
      } else {
        Toast.error("Network error. Please check your connection and try again.");
      }
    }
  };

  // Close popup
  const handlePopupClose = () => {
    setOpenPopup(false);
  };

  // Fetch candidate details
  const getSelectedCandidateDetails = async (candidateId) => {
    try {
      const response = await aiDishaApi.get(`/get-candidates-by-candidate-id?candidate_id=${candidateId}`);
      if (response.data) {
        copyCandidateDetails(response.data);
      } else {
        Toast.error("No candidate data found.");
        throw new Error("No data returned for candidate");
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
      throw error;
    }
  };

  // Handle view/edit candidate
  const handleViewEditCandidate = async (candidateId, reason) => {
    console.log("CandidateID:", candidateId);
    console.log("Reason:", reason);

    try {
      await getSelectedCandidateDetails(candidateId);
      setEditOrView(reason);
      setOpenPopup(true);
    } catch (error) {
      console.error(`Error in ${reason} candidate:`, error);
      Toast.error("Something went wrong while fetching candidate details.");
    }
  };

  // Delete candidate
  const handleDeleteCandidate = () => {
    aiDishaApi
      .put(`/delete-candidate/?candidate_id=${candidateIdToDelete}`)
      .then((response) => {
        toast.success("Candidate deleted");
        fetchData();
        setDeleteModalOpen(false);
      })
      .catch((error) => {
        console.error("Error deleting candidate:", error);
        Toast.error("Failed to delete candidate");
        setDeleteModalOpen(false);
      });
  };

  // Copy candidate details to formData
  const copyCandidateDetails = (candidateData) => {
    let years = "";
    let months = "";

    if (candidateData.experience) {
      years = Math.floor(candidateData.experience);
      months = Math.round((candidateData.experience - years) * 12);
    }

    setFormData({
      ...formData,
      candidate_id: candidateData.candidate_id,
      candidate_full_name: candidateData.candidate_full_name,
      email_id: candidateData.email_id,
      job_title: candidateData.job_title,
      job_id: candidateData.job_id,
      skills: candidateData.skills || "",
      educational_qualification: candidateData.educational_qualification,
      experience_years: years,
      experience_months: months,
    });
  };

  // Clear form
  const clearForm = () => {
    setFormData({
      candidate_id: "",
      candidate_full_name: "",
      email_id: "",
      job_title: "",
      job_id: "",
      skills: "",
      educational_qualification: "",
      experience_years: "",
      experience_months: "",
    });
  };

  const candidate_headers = [
    {
      candidateId: "Candidate ID",
      candidateName: "Candidate Name",
      email: "Email ID",
      file_name: "Resume",
      action: "Action",
    },
  ];

  // AI Screening Modal Component
  const AiScreeningModal = () => (
    <Dialog
      open={aiScreeningOpen}
      onClose={handleCloseAiScreening}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: '80vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        background: 'linear-gradient(135deg, #033538 0%, #006A71 100%)', 
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 3
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <PsychologyIcon sx={{ fontSize: 32 }} />
          <Typography variant="h5" sx={{ fontFamily: 'Poppins', fontWeight: 600 }}>
            AI Resume Screening Analysis
          </Typography>
        </Box>
        <IconButton onClick={handleCloseAiScreening} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ padding: 3, background: 'white', marginTop:"20px"}}>
        {loadingAiData ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 4 }}>
            <LinearProgress sx={{ width: '100%', height: 8, borderRadius: 4 }} />
            <Typography sx={{ fontFamily: 'Poppins', color: '#033538' }}>
              Analyzing candidate resume...
            </Typography>
          </Box>
        ) : aiScreeningData ? (
          <Grid container spacing={3}>
            {/* Overall Score Card */}
            <Grid item xs={12}>
              <Card sx={{ 
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                color: 'white',
                borderRadius: 3,
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
              }}>
                <CardContent sx={{ textAlign: 'center', padding: 3 }}>
                  <Typography variant="h6" sx={{ fontFamily: 'Poppins', mb: 1,color: 'Black' }}>
                    Overall Screening Score
                  </Typography>
                  <Typography variant="h2" sx={{ fontFamily: 'Poppins', fontWeight: 'bold', mb: 1, color: 'Black' }}>
                    {aiScreeningData.ai_result.ai_score || '85'}%
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} sx={{ 
                        color: i < Math.floor((aiScreeningData.ai_result.ai_score || 85) / 20) ? '#FFD700' : 'Black' 
                      }} />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Skills Analysis */}
            <Grid item xs={12} md={6}>
              <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#033538', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleIcon sx={{ color: '#4CAF50' }} />
                    Skills Match Analysis
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {(aiScreeningData.ai_result.matched_skills || [
                      { skill: 'React.js', match: 95, level: 'Expert' },
                      { skill: 'Node.js', match: 88, level: 'Advanced' },
                      { skill: 'Python', match: 75, level: 'Intermediate' },
                      { skill: 'SQL', match: 82, level: 'Advanced' }
                    ]).map((skill, index) => (
                      <Box key={index}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, fontWeight: 500, color:'black' }}>
                            {skill}
                          </Typography>
                          <Chip 
                            label="100"
                            size="small" 
                            sx={{ 
                              backgroundColor: skill.match > 80 ? '#4CAF50' : skill.match > 60 ? '#FF9800' : '#F44336',
                              color: 'white',
                              fontFamily: 'Poppins'
                            }}
                          />
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value="100"
                          sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: '#E0E0E0',
                            '& .MuiLinearProgress-bar': {
                              backgroundColor: skill.match > 80 ? '#4CAF50' : skill.match > 60 ? '#FF9800' : '#F44336',
                              borderRadius: 4
                            }
                          }}
                        />
                        <Typography sx={{ fontSize: 12, color: '#666', mt: 0.5 }}>
                          100% match
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Experience Analysis */}
            <Grid item xs={12} md={6}>
              <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#033538', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleIcon sx={{ color: '#2196F3' }} />
                    Experience Analysis
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ 
                      p: 2, 
                      borderRadius: 2, 
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white'
                    }}>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, mb: 1, color:'black' }}>
                        Total Experience
                      </Typography>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: 24, fontWeight: 'bold' , color:'black'}}>
                        {aiScreeningData.ai_result.experience_analysis || '5.2 Years'}
                      </Typography>
                    </Box>
                    <Box sx={{ 
                      p: 2, 
                      borderRadius: 2, 
                      background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                      color: '#333'
                    }}>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, mb: 1 , color:'black'}}>
                        Relevant Experience
                      </Typography>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: 24, fontWeight: 'bold' , color:'black'}}>
                        {aiScreeningData.relevant_experience || '4.1 Years'}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Strengths and Weaknesses */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: 'red', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CheckCircleIcon />
                         Missing skills
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 , color:'black'}}>
                        {(aiScreeningData.ai_result.missing_skills || [
                          'Strong technical background in modern web technologies',
                          'Excellent problem-solving skills demonstrated through projects',
                          'Good communication and teamwork experience',
                          'Continuous learning attitude with recent certifications'
                        ]).map((skill, index) => (
                          <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            <CheckCircleIcon sx={{ color: '#4CAF50', fontSize: 16, mt: 0.2 }} />
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, color:'black' }}>
                              {skill}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: 'green', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CheckCircleIcon/>
                        Scores
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* {(aiScreeningData.weaknesses || [
                          'Limited experience with cloud platforms',
                          'Could benefit from more leadership experience',
                          'Gap in testing and quality assurance knowledge'
                        ]).map((weakness, index) => ( */}
                          <Box  sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 ,color:'black'}}>
                            <CheckCircleIcon sx={{ color: '#FF5722', fontSize: 16, mt: 0.2, color:'black' }} />
                            CONFIDENCE SCORE :
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, color:'black' }}>
                              {aiScreeningData.ai_result.confidence_score}
                            </Typography>
                          </Box>
                          <Box  sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, color:'black' }}>
                            <CheckCircleIcon sx={{ color: '#FF5722', fontSize: 16, mt: 0.2, color:'black' }} />
                            EDUCATION MATCHED SCORE :
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, color:'black' }}>
                              {aiScreeningData.ai_result.education_match_score}
                            </Typography>
                          </Box>
                          <Box  sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, color:'black' }}>
                            <CheckCircleIcon sx={{ color: '#FF5722', fontSize: 16, mt: 0.2, color:'black' }} />
                            Experience MATCHED SCORE :
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, color:'black' }}>
                              {aiScreeningData.ai_result.experience_match_score}
                            </Typography>
                          </Box>
                          <Box  sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, color:'black' }}>
                            <CheckCircleIcon sx={{ color: '#FF5722', fontSize: 16, mt: 0.2, color:'black' }} />
                            SKILLS MATCHED SCORE :
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, color:'black' }}>
                              {aiScreeningData.ai_result.skills_match_score}
                            </Typography>
                          </Box>
                        {/* ))} */}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* AI Recommendation */}
            <Grid item xs={12}>
              <Card sx={{ 
                borderRadius: 3, 
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white'
              }}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontFamily: 'Poppins', mb: 2, display: 'flex', alignItems: 'center', gap: 1, color:'white' }}>
                    <PsychologyIcon />
                    AI Recommendation
                  </Typography>
                  <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, lineHeight: 1.6, color:'black' }}>
                    {aiScreeningData.ai_result.ai_recommendations || 
                     'This candidate shows strong potential with excellent technical skills and relevant experience. ' +
                     'The candidate demonstrates a good fit for the role with minor gaps that can be addressed through training. ' +
                     'Recommend proceeding to technical interview stage with focus on cloud technologies and leadership scenarios.'}
                  </Typography>
                  <Box sx={{ mt: 2, display: 'flex', gap: 1, color:'black' }}>
                    Over ALL Score:
                    <Chip 
                      label={aiScreeningData.ai_result.overall_ranking || "76 / 100"} 
                      sx={{ 
                        backgroundColor: 'rgba(255,255,255,0.2)', 
                        color: 'black', 
                        fontFamily: 'Poppins',
                        fontWeight: 'bold'
                      }} 
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Typography sx={{ textAlign: 'center', color: '#666', py: 4 }}>
            No AI screening data available for this candidate.
          </Typography>
        )}
      </DialogContent>
      
      <DialogActions sx={{ padding: 3, background: '#f5f5f5' }}>
        <Button 
          onClick={handleCloseAiScreening}
          variant="contained"
          sx={{ 
            backgroundColor: '#033538',
            color: 'white',
            fontFamily: 'Poppins',
            borderRadius: 2,
            px: 3
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  return isAddCandidateOpen ? (
    <Box
      sx={{
        marginTop: "25px",
        borderRadius: "10px",
        backgroundColor: "#33333",
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
      }}
    >
      <AddNewCandidate />
    </Box>
  ) : (
    <div
      style={{
        height: "calc(100% - 6%)",
        width: "100%",
        overflow: "scroll",
        overflowX: "hidden",
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "3%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}
          >
            View Candidate
          </Typography>
        </Box>

        <Box
          gridColumn="span 8"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "75%",
              borderRadius: 2,
              backgroundColor: "#033538",
            }}
          >
            <IconButton
              type="button"
              sx={{ p: "8px", color: "white" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }}
              placeholder="Search by Candidate Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>

        <Box
          gridColumn="span 4"
          sx={{ marginTop: "auto", textAlign: "center" }}
        >
          <Button
            variant="contained"
            onClick={handleAddCandidate}
            sx={{
              backgroundColor: "#033538",
              marginRight: "10px",
              color: "white",
              fontFamily: "poppins",
            }}
          >
            Add New Candidate
          </Button>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: "#33333" }} justifyContent="center">
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={12} sm={10} md={10} justifyContent="center">
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "5px",
                maxHeight: "400px",
                overflowY: "auto",
                maxWidth: "100%",
                overflowX: "auto",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {candidate_headers.map((candidate) => (
                    <TableRow key={candidate.candidateId}>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {candidate.candidateId}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {candidate.candidateName}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {candidate.email}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {candidate.file_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0, minWidth: "220px" }}>
                        {candidate.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredCandidates
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((candidate) => (
                      <TableRow
                        key={candidate.candidate_id}
                        sx={{ backgroundColor: "#033538", marginRight: "10px" }}
                      >
                        <TableCell sx={{ color: "white", border: "1px solid black" }}>
                          {candidate.candidate_id}
                        </TableCell>
                        <TableCell sx={{ color: "white", border: "1px solid black" }}>
                          {candidate.candidate_full_name}
                        </TableCell>
                        <TableCell sx={{ color: "white", border: "1px solid black" }}>
                          {candidate.email_id}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            border: "1px solid black",
                            maxWidth: "250px",
                          }}
                        >
                          {candidate.resume_url && (
                            <div>
                              <span>
                                {new URL(candidate.resume_url).pathname.split("/").pop()}
                              </span>
                              <IconButton
                                onClick={() => handleDownload(candidate.resume_url)}
                                size="small"
                                sx={{ marginLeft: 1 }}
                              >
                                <DownloadIcon fontSize="small" />
                              </IconButton>
                            </div>
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid black",
                            borderRight: "1px solid black",
                            alignItems: "center",
                            minWidth: "220px",
                            padding: "8px"
                          }}
                        >
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px", justifyContent: "flex-start" }}>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "black",
                                color: "white",
                                fontFamily: "poppins",
                                height: "28px",
                                minWidth: "50px",
                                fontSize: "10px",
                                padding: "4px 8px"
                              }}
                              onClick={() =>
                                handleViewEditCandidate(candidate.candidate_id, "View")
                              }
                            >
                              View
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "black",
                                color: "white",
                                fontFamily: "poppins",
                                height: "28px",
                                minWidth: "50px",
                                fontSize: "10px",
                                padding: "4px 8px"
                              }}
                              onClick={() =>
                                handleViewEditCandidate(candidate.candidate_id, "Edit")
                              }
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                color: "white",
                                fontFamily: "poppins",
                                height: "28px",
                                minWidth: "50px",
                                fontSize: "10px",
                                padding: "4px 8px"
                              }}
                              color="error"
                              onClick={() => handleOpenDeleteModal(candidate.candidate_id)}
                            >
                              Delete
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#4CAF50",
                                color: "white",
                                fontFamily: "poppins",
                                height: "28px",
                                minWidth: "50px",
                                fontSize: "9px",
                                padding: "4px 8px",
                                "&:hover": {
                                  backgroundColor: "#45a049"
                                }
                              }}
                              onClick={() => handleAiScreening(candidate.candidate_id)}
                              disabled={loadingAiData}
                            >
                              {loadingAiData ? "..." : "AI Screen"}
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredCandidates.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>

      {/* AI Screening Modal */}
      <AiScreeningModal />

      <Modal isOpen={isModalOpen} onClose={handleModalClose} title="Candidate" />

      <EditPopup
        title="View/Edit Candidate"
        openPopupVar={openPopup}
        setOpenPopupMet={setOpenPopup}
      >
        <div
          style={{
            display: "block",
            backgroundColor: "white",
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <div className="modal-header border-0">
            <label style={{ color: "black", fontSize: "18px" }}>{editOrView} Candidate</label>
            <button type="button" className="btn-close" onClick={handlePopupClose}></button>
          </div>

          <form onSubmit={handleEditJob}>
            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="candidateId"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Candidate ID
                </label>
                <input
                  type="text"
                  name="candidateId"
                  className="form-control form-control-sm"
                  value={formData.candidate_id}
                  onChange={(e) =>
                    setFormData({ ...formData, candidate_id: e.target.value })
                  }
                  aria-label="Candidate ID"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  readOnly
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="candidateFullName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Candidate Full Name
                </label>
                <input
                  type="text"
                  name="candidateFullName"
                  className="form-control form-control-sm"
                  value={formData.candidate_full_name}
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      candidate_full_name: e.target.value,
                    })
                  }
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="emailId"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Email ID
                </label>
                <input
                  type="text"
                  name="emailId"
                  className="form-control form-control-sm"
                  onChange={(e) =>
                    setFormData({ ...formData, email_id: e.target.value })
                  }
                  value={formData.email_id}
                  aria-label="Email ID"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="jobTitle"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Job Title
                </label>
                <input
                  type="text"
                  name="jobTitle"
                  className="form-control form-control-sm"
                  onChange={(e) =>
                    setFormData({ ...formData, job_title: e.target.value })
                  }
                  value={formData.job_title}
                  aria-label="Job Title"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="qualification"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Qualification
                </label>
                <input
                  type="text"
                  name="qualification"
                  className="form-control form-control-sm"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      educational_qualification: e.target.value,
                    })
                  }
                  value={formData.educational_qualification}
                  aria-label="Qualification"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="skills"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Skills
                </label>
                <input
                  type="text"
                  name="skills"
                  className="form-control form-control-sm"
                  onChange={(e) =>
                    setFormData({ ...formData, skills: e.target.value })
                  }
                  value={formData.skills}
                  aria-label="Skills"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="experienceYears"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Experience in Years
                </label>
                <input
                  type="text"
                  name="experienceYears"
                  className="form-control form-control-sm"
                  value={formData.experience_years}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      experience_years: e.target.value,
                    })
                  }
                  aria-label="Experience in Years"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
              <div className="col-sm-6">
                <label
                  className="aa"
                  htmlFor="experienceMonths"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#033538",
                  }}
                >
                  Experience in Months
                </label>
                <input
                  type="text"
                  name="experienceMonths"
                  className="form-control form-control-sm"
                  value={formData.experience_months}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      experience_months: e.target.value,
                    })
                  }
                  aria-label="Experience in Months"
                  style={{
                    backgroundColor: "#033538",
                    border: "none",
                    width: "100%",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "white",
                  }}
                  disabled={editOrView === "View"}
                />
              </div>
            </div>

            <div className="modal-footer d-flex flex-row justify-content-right border-0">
              <button
                type="button"
                className="btn btn-sm rounded-2 fw-medium"
                onClick={clearForm}
                style={{
                  color: "#033538",
                  width: "120px",
                  border: "1px solid #033538",
                }}
                hidden={editOrView === "View"}
              >
                Clear
              </button>
              <button
                type="submit"
                className="btn btn-sm rounded-2 fw-medium"
                style={{
                  backgroundColor: "#033538",
                  color: "#E8E8E8",
                  width: "120px",
                }}
                hidden={editOrView === "View"}
              >
                Submit
              </button>
            </div>
            <br />
            <br />
            <br />
          </form>
        </div>
      </EditPopup>

      <DeleteCandidateModal
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteCandidate}
      />
    </div>
  );
};

export default ViewCandidate;